export default "__VITE_ASSET__DaYYyyVc__"